import { db } from "../firebase";
import { doc, collection, deleteDoc } from "firebase/firestore";

export default function useDeleteDoc({ coll }) {
    const del = (id) => {
        const docRef = doc(collection(db, coll), id);
        return deleteDoc(docRef)
    }
    return { del }
}